const header = {
  homepage: '/',
  title: 'TT.',
}

const about = {
  name: 'Tilak Tank',
  role: 'Front End Developer',
  description:
    'A Web Developer who likes to work on a challenging job profile. Always looking forward for the opportunity to enhance skills and knowledge, which could provide an insight into new aspects so that it would be helpful for the career.',
  social: {
    linkedin: 'https://www.linkedin.com/in/tilaktank/',
    github: 'https://github.com/tilaktank',
  },
}
const edu = [
  {
    id:1,
    uniname: 'GTU',
    year: '2020-2023',
    course: 'Bachelors',
    description:
      'Persuing B.E. in Computer Science & Engineering from SLTIET College, Rajkot, Gujarat, India.',
  },
  {
    id:2,
    uniname: 'GTU',
    year: '2017-2020',
    course: 'Diploma',
    description:
      'Persue Diploma in Computer Engineering from AVPTI College, Rajkot, Gujarat, India.',
  }  
]

const projects = [
  {
    name: 'TODO',
    description: 'TODO least using ReactJs',
    stack: ['ReactJs', 'HTML', 'Bootstrap', 'CSS'],
    // sourceCode: 'https://github.com',
    // livePreview: 'https://github.com',
  },
  {
    name: "GTK'22",
    description:
      'Website for technical event “Gurutvakarshan 2022” of the college.',
    stack: ['PHP', 'HTML', 'Bootstrap', 'CSS'],
    // sourceCode: 'https://github.com',
    // livePreview: 'https://github.com',
  },
  {
    name: 'Centennial',
    description: 'Website for an organization.',
    stack: ['PHP', 'HTML', 'Bootstrap', 'CSS'],
    // sourceCode: 'https://github.com',
    // livePreview: 'https://github.com',
  },
  {
    name: 'Portfolio',
    description: 'First web project - Personal Portfolio',
    stack: ['HTML', 'Bootstrap', 'CSS'],
    // sourceCode: 'https://github.com',
    // livePreview: 'https://github.com',
  },
]

const skills = [
  'React',
  'HTML',
  'CSS',
  'JavaScript',
  'Git',
  'Bootstrap',
  'PHP',
  'UI Designing',
  'Adobe Illustrator',
  'Adobe Photoshop',
]

const contact = {
  email: 'tilak1422001+vercel_portfolio@gmail.com',
}

export { header, about, edu, projects, skills, contact }
